import { makeStyles } from "@mui/styles";
import theme from "src/theme";
import {
    MAX_XL_TABLET,
} from "src/pages/game-new2/constants";
import { windowsSizeParams } from "src/consts/window-size-params";

export const useStyles = makeStyles({
    modalSettingsMain: {
        background: "transparent",
        border: "none",
    },

    modalSettingsWrapper: {
        position: "absolute",
        top: `${windowsSizeParams.largeTabletAppBarHeight}px`,
        left: "50%",
        transform: "translate(-50%, 0%)",
        boxShadow: "0px 22.32369613647461px 90px 0px #00000080",
        border: "none",
        outline: "none",
        background: 'rgba(13, 14, 15, 0.9)',
        [theme.breakpoints.up("xs")]: {
            borderRadius: 15,
        },
        [theme.breakpoints.up(MAX_XL_TABLET)]: {
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            maxWidth: "700px",
            width: "70%",
            minHeight: "400px",
            maxHeight: "500px",
            height: "calc(100vh - 150px)",
            padding: 20,
            borderRadius: 24,
        },
    },

    returnToPreviousWrapper: {
        position: "absolute",
        width: "130px",
        height: "60px",
        overflow: "hidden",
        [theme.breakpoints.up("xs")]: {
            bottom: "5px",
            left: "7px",
            height: "45px",
        },
        [theme.breakpoints.up(MAX_XL_TABLET)]: {
            bottom: "10px",
            left: "20px",
        },
    },

    modalTopBox: {
        width: "100%",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        marginBottom: 24,
        height: 50,
    },
    title: {
        fontSize: 24,
        fontWeight: 500,
        color: 'rgba(245, 245, 245, 0.9)',
        "&.isCustom": {
            [theme.breakpoints.up("lg")]: {
                marginBottom: 10,
            },
            [theme.breakpoints.down("lg")]: {
                margin: "0 auto",
                marginBottom: 0,
                marginTop: 20,
            },
        },
        "&.getOwn": {
            textAlign: "center",
            [theme.breakpoints.up("lg")]: {
                display: "flex",
                alignItems: "center",
                fontSize: 24,
            },
            [theme.breakpoints.down("lg")]: {
                display: "flex",
                alignItems: "center",
                fontSize: 18,
            },
        },
    },
    closeIcon: {
        width: 24,
        height: 24,
        objectFit: "contain",
        cursor: "pointer",
        position: "absolute",
        top: "20px",
        right: "10px",
        [theme.breakpoints.up("md")]: {
            right: "20px",
        },
    },
});
